/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules
import 'bootstrap';
import _ from 'lodash';
import Colcade from 'colcade';
// import Swiper from 'swiper/bundle';
import Bootstrap from './modules/bootstrap.js';
import Destinations from './modules/destinations.js';
import QuickFilter from './modules/quick-filter.js';
import GoogleMaps from './modules/google-maps.js';
import Favorites from './modules/favorites.js';
import Search from './modules/search.js';
document.addEventListener('DOMContentLoaded', () => {let search = new Search();});

const bootstrap = new Bootstrap();
const quickFilter = new QuickFilter();
const destinations = new Destinations();
const googleMaps = new GoogleMaps();
const favorites = new Favorites();

let accordionBlocks = Array.from(document.querySelectorAll('.accordion-block'));
let carouselBlocks = Array.from(document.querySelectorAll('.swiper-container'));
let destinationsGrid = document.querySelector('.destinations-grid')

/**
 * Add .is-sticky to .site-header when scrolling
 *
 * {@link https://css-tricks.com/debouncing-throttling-explained-examples/}
 */
let siteHeader = document.querySelector('.site-header'),
	latestKnownScrollY = window.scrollY;

if (latestKnownScrollY > 0) {
	siteHeader.classList.add('is-sticky');
}

function onScroll() {
	latestKnownScrollY = window.scrollY;

	if (latestKnownScrollY > 0) {
		siteHeader.classList.add('is-sticky');
	} else {
		siteHeader.classList.remove('is-sticky');
	}
}

window.addEventListener('scroll', _.throttle(onScroll, 16), false);

/**
 * Animate [loading="lazy"]
 * {@link https://web.dev/lazy-loading-video/ }
 */
document.addEventListener('DOMContentLoaded', () => {
	var lazyElements = [].slice.call(document.querySelectorAll('[loading="lazy"]'));

	if ("IntersectionObserver" in window) {
		var lazyElementObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (element) {
				if (element.isIntersecting) {
					element.target.classList.add('lazyloaded');
					lazyElementObserver.unobserve(element.target);
				}
			});
		});

		lazyElements.forEach(function (lazyVideo) {
			lazyElementObserver.observe(lazyVideo);
		});
	}
});

/**
 * Accordion with masonry layout with Colcade
 * {@link https://github.com/desandro/colcade }
 */
if (accordionBlocks.length) {
	accordionBlocks.forEach((element) => {
		var grid = element.querySelector('.accordion');

		var colcade = new Colcade(grid, {
			columns: '.accordion-col',
			items: '.accordion-item'
		});
	});
}
document.addEventListener('DOMContentLoaded', function () {
	carouselBlocks.forEach( ( element ) => {
		// Ensure the element is correctly selected

		if (!element) {
			console.error('Swiper container not found');
			return;
		}

		// Ensure pagination and navigation elements exist within the swiper container
		let nextEl = element.querySelector('.swiper-button-next');
		let prevEl = element.querySelector('.swiper-button-prev');

		if (!nextEl || !prevEl) {
			console.error('Swiper elements (pagination or navigation) not found on');
			console.error(element);
			return;
		}

		// Initialize Swiper
		let swiper = new Swiper(element, {
			slidesPerView: 3,
			loop: true,
			navigation: {
				nextEl: nextEl,
				prevEl: prevEl
			},
			breakpoints: {
				320: {
					slidesPerView: 1
				},
				480: {
					slidesPerView: 2
				},
				640: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				},
				1024: {
					slidesPerView: 3
				},
				1280: {
					slidesPerView: 3
				},
				1440: {
					slidesPerView: 3
				}
			}
		});

		console.log('Swiper initialized:', swiper);
	});
});

/**
 * Downscale card rows to carousels with Swiper
 * {@link https://github.com/nolimits4web/swiper }
 */

/**
 * Viewport based destinations grid size
 */

function setDestinationsGridHeight() {
	var destinationsGridHeight = 'height: auto !important;';

	if (window.innerWidth > 767) {
		destinationsGridHeight = 'height: calc(100vh - ' + siteHeader.offsetHeight + 'px) !important;';
	}

	destinationsGrid.setAttribute('style', destinationsGridHeight);
}

if (destinationsGrid) {

	document.addEventListener('DOMContentLoaded', () => {
		setDestinationsGridHeight();
	});

	window.addEventListener('resize', _.throttle(setDestinationsGridHeight, 16), false);
}



